import React from 'react';
import PropTypes from 'prop-types';
import Link from '@material-ui/core/Link';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import ButtonBase from '@material-ui/core/ButtonBase';
import {doHelpSupportModal as doHelpSupportModalAction} from 'components/Dialogs/HelpSupportDialog/actions';
import { useDispatch } from 'react-redux';

const HelpSupportButton = (props) => {
  const { classes } = props;
  const dispatch = useDispatch();

  return (
    <ButtonBase
      className={classes.navMenuItem}
      component={React.forwardRef((propers, ref) => <Link {...propers} innerRef={ref} underline="none"/>)}
      id="nav-menu-shared-components"
      onClick={()=> dispatch(doHelpSupportModalAction())}
    >
      <div>
        <HelpOutlineIcon titleAccess="Help"/>
      </div>
      <div style={{ marginLeft: 24, textAlign: 'left' }} className={classes.navText}>
        Help
      </div>
    </ButtonBase>
  );
};

HelpSupportButton.propTypes = {
  classes: PropTypes.object,
};

export default HelpSupportButton;
